import { useSeriesByTagSlug, useSeriesEntertainersQuery } from '@queries/TagQueries';

import { useCityById } from '@hooks/useCurrentUserLocation';

export const useCityDragKingSeriesEntertainers = (cityId: string) => {
  const { city } = useCityById(cityId);

  const { isFetched: isSeriesReady, series } = useSeriesByTagSlug(
    city?.featuredSeries?.kingsThings,
  );

  return useSeriesEntertainersQuery(series?._id, Boolean(series?.isEntertainerSeries));
};
